module.exports = __webpack_public_path__ + "static/media/dsilv_coggers.dfde4e29.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/dsilv_coggers.gif
// module id = 320
// module chunks = 0